import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import TeamSectionStyle2 from '../Section/TeamSection/TeamSectionStyle2';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
const teamData = [
  {
    imgUrl: '/images/home_1/pro1.jpeg',
    department: 'SAM ROSE',
    name: 'Ferrous Bisglycinate, Folic Acid & Vitamin C',
    designation: 'Consectetur Adipiscing Elit Sed Do Eiusmod',
    description:
      'The healthy balanced diet should include a variety of vitamins, minerals, fiber and healthy fat. In a healthy balanced diet we cannot miss folic acid.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    category: 'cardiology',
    href: '/products/samrose',
  },
  {
    imgUrl: '/images/home_1/pro2.jpeg',
    department: 'SAMAF',
    name: 'Coral calcuim & Cholecalciferol',
    designation: 'Consectetur Adipiscing Elit Sed Do Eiusmod',
    description:
      ' It has many roles in your body and is particularly important during certain developmental stages.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    category: 'cardiology',
    href: '/products/samaf',
  },
  {
    imgUrl: '/images/home_1/pro3.jpeg',
    department: 'S-TIG',
    name: 'Male Firtility Enhancer',
    designation: 'Consectetur Adipiscing Elit Sed Do Eiusmod',
    description:
      ' This extract may help improve blood flow to the penis, potentially leading to firmer erections.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    category: 'cardiology',
    href: '/products/stig',
  },
  {
    imgUrl: '/images/home_1/pro10.jpeg',
    department: 'KIASAM',
    name: 'Natural Acids',
    designation: 'Consectetur Adipiscing Elit Sed Do Eiusmod',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    category: 'cardiology',
    href: '/products/kiasam',
  },
  {
    imgUrl: '/images/home_1/pro5.jpeg',
    department: 'CALSAM',
    name: 'Instant Calcium with Vitamin C',
    designation: 'Consectetur Adipiscing Elit Sed Do Eiusmod',
    description:
      'Introducing Vitamin C & Antioxidants, a dietary supplement formulated with Vitamin C to boost immune suppor',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    category: 'cardiology',
    href: '/products/calsam',
  },
  {
    imgUrl: '/images/home_1/pro6.jpeg',
    department: 'CRAN-S',
    name: 'Cranberry Standardized Extract',
    designation: 'Consectetur Adipiscing Elit Sed Do Eiusmod',
    description:
      'Cranberry extract is derived from the fruit of the cranberry plant, scientifically known as Vaccinium macrocarpon',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    category: 'cardiology',
    href: '/products/cran',
  },
  
 
];

export default function Doctors() {
  pageTitle('Products');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/doctors/herobg.jpg"
        imgUrl="/images/doctors/hero.jpg"
        title="Discover Excellence in Health &<br /> Wellness Products"
        subTitle="Empowering Lives with Premium Nutraceuticals, Herbal Remedies, and Veterinary Solutions."
      />
      <Section topMd={65} bottomMd={200} bottomLg={150} bottomXl={110}>
        <TeamSectionStyle2 data={teamData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/home_1/h1.jpg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section>
    </>
  );
}
